import { render, staticRenderFns } from "./CreateAttributeValueModal.vue?vue&type=template&id=418c786a&scoped=true"
import script from "./CreateAttributeValueModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAttributeValueModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateAttributeValueModal.vue?vue&type=style&index=0&id=418c786a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c786a",
  null
  
)

export default component.exports